<template>
    <div>
        <l-headline
            :title="$t('profile.notif.titleVisitor', { firstname: user.firstname })"
            :tabs="tabs"
        />
        <div>
            <l-skeleton-loader v-if="isLoading" />

            <div v-else-if="!notifications.length" class="tw-text-gray-400">
                {{ $t("profile.notif.emptyVisitor") }}
            </div>

            <l-notifications-list v-else :notifications="notifications" :is-visitor="true" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LHeadline from "@/components/LHeadline";
import LSkeletonLoader from "@/components/LSkeletonLoader";
import LNotificationsList from "@/components/LUserProfile/LNotificationsList";

export default {
    components: {
        LHeadline,
        LSkeletonLoader,
        LNotificationsList,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapGetters({
            notifications: "notifications/profilePreview/notifications",
            currentUser: "users/current/user",
        }),
        tabs() {
            return [
                {
                    label: this.$t("userlist.show.btnPrivateNote"),
                    path: `/profile/${this.user._id}/feedback/create?to=${this.user._id}&type=privateNote`,
                    show: true,
                    testId: "create-private-note",
                },
                {
                    label: this.$t("userlist.show.btnRequestFeedback"),
                    path: `/profile/${this.user._id}/feedback/request?to=${this.user._id}&`,
                    show: this.currentUser.rights.F_INSTANT,
                    tabClass: "hidden-xs",
                    testId: "request-feedback",
                },
                {
                    label: this.$t("userlist.show.btnGiveFeedback"),
                    path: `/profile/${this.user._id}/feedback/create?to=${this.user._id}`,
                    show: this.currentUser.rights.F_INSTANT,
                    testId: "give-feedback",
                },
                {
                    label: this.$t("userlist.show.btnCreatePraise"),
                    path: `/profile/${this.user._id}/feedback/create/praise?to=${this.user._id}&type=thanks-note`,
                    show: this.currentUser.rights.F_PRAISE,
                    testId: "send-praise",
                },
            ];
        },
    },
    async mounted() {
        try {
            await this.$store.dispatch("notifications/profilePreview/getNotifications", {
                payload: { userId: this.user._id },
            });
        } finally {
            this.isLoading = false;
        }
    },
};
</script>
